import styles from './MessageLoading.module.scss';
import BotHead from '../BotHead';

const MessageLoading = () => {
  return (
    <>
      <BotHead />
      <div className={styles.MessageArea}>
        <div className={styles.LoadingDot}>
          <span></span> <span></span> <span></span>
        </div>
      </div>
    </>
  );
};

export default MessageLoading;
